let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fjU4V")).then(() => parcelRequire('aWGP9'));